import moment from 'moment';

export default function formatTimestamp(timestamp) {
  return moment(timestamp).format('YYYY-MM-DD');
}
